import { Skeleton, Toast } from 'antd-mobile'
import { ReactElement, useEffect, useMemo } from 'react'
import style from './index.module.less'
import qs from 'query-string'

function Main (): ReactElement {
  const url = useMemo(() => {
    const p = qs.parse(location.search)
    return p.url
  }, [])
  useEffect(() => {
    if (typeof url === 'string' && url !== '') {
      location.href = `${location.origin}${url}?v=${Date.now()}`
    } else {
      Toast.show({ content: 'url不能为空' })
    }
  }, [url])
  return (
    <div className={style.container}>
      <div className={style.inner}>
        <Skeleton.Title animated />
        <Skeleton.Paragraph lineCount={5} animated />
      </div>
    </div>
  )
}

export default Main
